import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './grow/context/AuthContext';
import { signOut, auth } from './grow/firebase/firebase';
import LoadingPage from './grow/components/LoadingPage';
import HomePage from './grow/components/HomePage';
import ProfilePage from './grow/components/ProfilePage';
import LoginPage from './grow/components/LoginPage';
import FirstTimeLogin from './grow/components/FirstTimeLogin';
import NPKComponent from './grow/components/NPKComponent';
import PlaceComponent from './grow/components/PlaceComponent';
import ProtectedRoute from './grow/components/ProtectedRoute';
import CropAddComponent from './grow/components/CropAddComponent';
import KnownCropsManager from './grow/components/KnownCropsManager';
import EstimationMeetComponent from './grow/components/EstimationMeetComponent';
import CropOverview from './grow/components/CropOverView';
import BackgroundVideo from './grow/components/BackgroundVideo';
import CropDetail from './grow/components/CropDetail';
import CropList from './grow/components/CropList';
import { getUserData } from './grow/firebase/firestoreService';
import MySowing from './grow/components/MySowing';
// import Test from './Test/Test';
import RecommandBasedOnKnownCrops from './grow/components/RecommandBasedOnKnownCrops';
import RecommandBasedOnSoilClimate from './grow/components/RecommandBasedOnSoilClimate';
import DashBoard from './grow/components/DashBoard';
import PptRedirect from './grow/utils/ppt_redirect';

// Main application content that handles routing, auth, and the layout.
const AppContent = () => {
  const { user, setUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // useNavigate hook for programmatic navigation

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [setUser]);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      setUser(null);
      navigate("/login", { replace: true });
    } catch (err) {
      console.error('Sign-out error: ', err.message);
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div style={{ position: 'relative', minHeight: '100vh', overflow: 'hidden' }}>
      <BackgroundVideo />
      {user ? (
        <div style={{ position: 'relative', zIndex: 1 }}> 
          {/* HomePage includes header and content */}
          {/* <HomePage user={user} onSignOut={handleSignOut} /> */}
          
          {/* Protected Routes */}
          <Routes>

            <Route path="/ppt" element={<PptRedirect></PptRedirect>} />
            <Route path="/login" element={<Navigate to={user ? "/dashboard" : "/login"} />} />

            {/* <Route path="/home" element={<ProtectedRoute><HomePage user={user} onSignOut={handleSignOut} /></ProtectedRoute>} /> */}
            <Route path="/dashboard" element={<ProtectedRoute><DashBoard user={user} onSignOut={handleSignOut} /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
            <Route path="/ftl" element={<ProtectedRoute><FirstTimeLogin email={user.email} /></ProtectedRoute>} />
            <Route path="/npk" element={<ProtectedRoute><NPKComponent email={user.email} /></ProtectedRoute>} />
            <Route path="/place" element={<ProtectedRoute><PlaceComponent email={user.email} /></ProtectedRoute>} />
            <Route path="/add" element={<ProtectedRoute><CropAddComponent email_1={user.email} /></ProtectedRoute>} />
            <Route path="/manage-crops" element={<ProtectedRoute><KnownCropsManager email={user.email} /></ProtectedRoute>} />
            <Route path="/demand" element={<ProtectedRoute><EstimationMeetComponent email={user.email} /></ProtectedRoute>} />
            <Route path="/my-sowing" element={<ProtectedRoute><MySowing email={user.email} /></ProtectedRoute>} />
            <Route path="/rec-known" element={<ProtectedRoute><RecommandBasedOnKnownCrops email={user.email} /></ProtectedRoute>} />
            <Route path="/rec-sc" element={<ProtectedRoute><RecommandBasedOnSoilClimate email={user.email} /></ProtectedRoute>} />
            { /* <Route path="/test" element={<ProtectedRoute><Test email={user.email} /></ProtectedRoute>} /> */}
            <Route path="/crop-detail/:cropName" element={<ProtectedRoute><CropDetail /></ProtectedRoute>} />
            <Route path="/crop-list" element={<ProtectedRoute><CropList /></ProtectedRoute>} />
            <Route path="/" element={<Navigate to="/dashboard" />} />
            
          </Routes>
        </div>
      ) : (
        <Routes>
          <Route path="/ppt" element={<PptRedirect></PptRedirect>} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/demand" element={<EstimationMeetComponent />} />
          <Route path="/" element={<Navigate to="/demand" />} />
          <Route path="*" element={<Navigate to="/demand" />} />
        </Routes>
      )}
    </div>
  );
};

const App = () => (
  <AuthProvider>
    <Router>
      <AppContent />
    </Router>
  </AuthProvider>
);

export default App;
